import {
    bexHttpClient
} from '../../clients';

export type MailProvider = 'smtp' | 'imap';

export interface MailSecretsRequest {
  organizationId: string;
  provider: MailProvider;
  user: string;
  pass: string;
}

/**
 * The API never returns the password — only whether one is set. That is the
 * contract, not a formatting choice: a stored credential is write-only.
 */
export interface MailProviderStatus {
  user: string;
  passSet: boolean;
}

export interface MailConfigResponse {
  data: {
    smtp: MailProviderStatus | null;
    imap: MailProviderStatus | null;
  };
}

/**
 * SMTP/IMAP mailbox credentials for email channels served by the bex-mail
 * exchange (provider "smtp"). Sibling of outlookConfigService; same auth
 * posture server-side (org super-admin only).
 */
class MailConfigService {

    /** Stores (or replaces) one provider's credential in the org's Vault. */
    async addMailSecrets(data: MailSecretsRequest): Promise<void> {
        await bexHttpClient.post('/mail/config/add-secrets', data);
    }

    /** Which credentials exist — usernames and set-flags, never passwords. */
    async getMailConfig(organizationId: string): Promise<MailConfigResponse> {
        const response = await bexHttpClient.get(`/mail/config/get-secrets?organizationId=${organizationId}`);
        return response;
    }

    async deleteMailSecrets(organizationId: string, provider: MailProvider): Promise<void> {
        await bexHttpClient.delete('/mail/config/delete-secrets', {
            data: {
                organizationId,
                provider
            }
        });
    }

}

const mailConfigService = new MailConfigService();
export { mailConfigService };
